export default function parseEntityField(entity, field = 'options') {
  const fieldIsJSON = entity[field] && typeof entity[field] === 'string';
  const updatedField = fieldIsJSON ? JSON.parse(entity[field]) : entity[field];

  return { ...entity, [field]: updatedField };
}
